import { Component, OnInit } from '@angular/core';
import { ProdutoService } from '@modules/produto/produto.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadService } from '@core/services/upload.service';

@Component({
  selector: 'app-trocar-produto-card',
  templateUrl: './trocar-produto-card.component.html',
  styleUrls: ['./trocar-produto-card.component.scss']
})
export class TrocarProdutoCardComponent implements OnInit {
  isVisible: boolean = false;
  listaProdutos: any[] = [];
  produtoSelecionado: any;
  dadosUser: any = {};
  itemSelecionado: any;
  imagemProduto: any;

  constructor(
    private produtoService: ProdutoService,
    private sanitizer: DomSanitizer,
    private uploadService: UploadService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.getProdutos();
    this.getProdutoSelecionado();
  }

  getProdutos() {
    this.produtoService.consultProdutosUsuario().subscribe((produtos) => this.listaProdutos = produtos);
  }

  getProdutoSelecionado() {
    this.dadosUser = this.authenticationService.currentUserValue;

    if (this.dadosUser?.produto) {
      this.produtoSelecionado = this.dadosUser.produto;
      console.log(this.produtoSelecionado)
      this.getImagem(this.produtoSelecionado.imagem);

    }

    if (!this.produtoSelecionado) {
      this.showModal();
    }
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.produtoService
      .trocarProduto(this.itemSelecionado.id)
      .subscribe((res) => {
        this.dadosUser.produto = {
          id: this.itemSelecionado.id,
          descricao: this.itemSelecionado.descricao,
          imagem: this.itemSelecionado.imagem || '',
        };
        this.produtoSelecionado = this.dadosUser.produto;
        this.authenticationService.setCurrentUser(this.dadosUser);
        this.isVisible = false;
        this.reloadRoute();
      });
  }

  reloadRoute() {
    window.location.reload();
    this.getProdutoSelecionado();
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  getImagem(img: any) {
    if (img) {
      this.uploadService.consultarPorId(img.id).subscribe((val: any) => {
        if (val) {
          val.subscribe((base64String: string) => {
            this.imagemProduto = base64String;
          })
        }
      })
    }
  }

  getSanitizedImageSrc(file: any) {
    return (file) ? this.sanitizer.bypassSecurityTrustUrl(file) : null;
  }
}
